import { memo } from 'react';
import { Box, Skeleton } from '@mui/material';

function LoadingSkeleton() {
  return (
    <Box display="flex" justifyContent="space-between" flexWrap="wrap">
      {Array(9)
        .fill(null)
        .map((_, i) => (
          <Skeleton key={i} variant="rectangular" width="32%" height={100} sx={{ mb: '1rem' }} />
        ))}
    </Box>
  );
}

export default memo(LoadingSkeleton);
